import { Anchor, Container, Paper, Stack, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { publishedGuidesBySection } from '#marketing/lib/guide-registry.js';
import { localePath } from '#marketing/lib/marketing-locale.js';
import { useMarketingLocale } from '#marketing/lib/use-marketing-locale.js';
import { MarketingSection } from './MarketingSection.jsx';

/**
 * Public /guides index, grouped by registry section. Rows without a youtubeId are omitted.
 */
export function MarketingGuidesPage() {
  const { t } = useTranslation('common');
  const locale = useMarketingLocale();
  const sections = publishedGuidesBySection();

  return (
    <Container size="md" py="xl">
      <MarketingSection
        titleKey="marketing.guides.heroTitle"
        descriptionKey="marketing.guides.heroDescription"
      />

      {sections.length === 0 ? (
        <Text c="dimmed" ta="center">
          {t('marketing.guides.empty')}
        </Text>
      ) : (
        <Stack gap="xl">
          {sections.map(({ section, videos }) => (
            <Stack key={section} gap="md">
              <Title order={2}>{t(`marketing.guides.sections.${section}`)}</Title>
              {videos.map((video) => {
                const descriptionKey = `marketing.guides.videos.${video.id}.description`;
                const description = t(descriptionKey);
                return (
                  <Paper key={video.id} withBorder p="md" radius="md" bg="white">
                    <Anchor
                      component={Link}
                      to={localePath(locale, `/guides/${video.id}`)}
                      fw={600}
                    >
                      {video.title}
                    </Anchor>
                    {description !== descriptionKey && (
                      <Text size="sm" c="dimmed" mt="xs">
                        {description}
                      </Text>
                    )}
                  </Paper>
                );
              })}
            </Stack>
          ))}
        </Stack>
      )}
    </Container>
  );
}
